module.exports = __webpack_public_path__ + "static/media/logo.43171858.png";